module.exports = __webpack_public_path__ + "img/valuationResultFast.26e87e23.png";